import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-05559fe9"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "critical-incidencia-banner",
  role: "alert",
  "aria-live": "assertive"
}
const _hoisted_2 = { class: "critical-incidencia-banner__content" }
const _hoisted_3 = { class: "critical-incidencia-banner__text" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "PELIGRO", -1))
const _hoisted_5 = {
  key: 0,
  class: "critical-incidencia-banner__title"
}

import { IonButton, IonIcon } from '@ionic/vue';
import { warningOutline } from 'ionicons/icons';
import { useRouter } from 'vue-router';
import { useOpenIncidencias } from '@/composables/unreadIncidencias';


export default /*#__PURE__*/_defineComponent({
  __name: 'CriticalIncidenciaBanner',
  setup(__props) {

const router = useRouter();
const {
  hasCriticalIncidencias,
  criticalIncidenciasCount,
  mostCriticalIncidencia,
} = useOpenIncidencias();

const goToIncidencias = () => {
  router.push('/organizacion/incidencias');
};

return (_ctx: any,_cache: any) => {
  return (_unref(hasCriticalIncidencias))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_unref(IonIcon), {
            icon: _unref(warningOutline),
            class: "critical-incidencia-banner__icon"
          }, null, 8, ["icon"]),
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createTextVNode(" — " + _toDisplayString(_unref(criticalIncidenciasCount)) + " incidencia" + _toDisplayString(_unref(criticalIncidenciasCount) === 1 ? '' : 's') + " crítica" + _toDisplayString(_unref(criticalIncidenciasCount) === 1 ? '' : 's') + " (prioridad < 6) ", 1),
            (_unref(mostCriticalIncidencia)?.title)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, " · " + _toDisplayString(_unref(mostCriticalIncidencia).title), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _createVNode(_unref(IonButton), {
          size: "small",
          fill: "solid",
          color: "light",
          onClick: goToIncidencias
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Ver ahora ")
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}
}

})